import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { DOWNSTREAM, UPSTREAM } from 'modules/HealthCheck/constants';
import NOB from '../../../constants/language-strings';
import { requestDevicePollingMac } from '../actions/devicePollingMacActions';
import samValueCorrector from '../../../utils/samValueCorrector';
import styled from 'styled-components';
import { Tabs } from '@purpurds/purpur/tabs';
import spacing from 'theme/spacing';
import { Loader } from 'components';
import { Overview, StreamChannel } from '../components/sam';
import { ErrorNotification } from 'components/error-notification/error-notification';
const DownstreamUpstream = styled.div `
  width: 100%;
  height: 100%;
  padding: ${spacing.spacing16} 0;
`;
const StyledTabs = styled(Tabs) `
  width: 100%;
  max-width: 750px;
  height: 100%;
`;
const Sam = ({ errorMessage, devicePollingMac, isReceiveFetching, isUpdateFetching, requestDevicePollingMacFunc, pollUrl, }) => {
    useEffect(() => {
        requestDevicePollingMacFunc(pollUrl);
    }, []);
    if (isReceiveFetching || isUpdateFetching) {
        return (_jsx(DownstreamUpstream, { children: _jsx(Loader, {}) }));
    }
    const devicePollingMacCorrected = devicePollingMac
        ? samValueCorrector(devicePollingMac)
        : { Success: false };
    return (_jsx(DownstreamUpstream, { children: !devicePollingMacCorrected.Success || errorMessage !== '' ? (_jsx(ErrorNotification, { title: NOB.FEEDBACKS.SORRY, text: errorMessage || NOB.HEALTH_CHECK.DEVICE_STATUS_ERROR })) : (_jsxs(StyledTabs, { variant: "contained", fullWidth: true, children: [_jsx(Tabs.Content, { name: NOB.DOWNSTREAM_UPSTREAM.OVERVIEW, tabId: "tab-1", children: _jsx(Overview, { devicePollingMac: devicePollingMacCorrected }) }), _jsx(Tabs.Content, { name: NOB.DOWNSTREAM_UPSTREAM.DS_CHANNEL, tabId: "tab-2", children: _jsx(StreamChannel, { channels: devicePollingMacCorrected.DsChannels, type: DOWNSTREAM, scoreVariables: devicePollingMacCorrected.ScoreVariables }) }), _jsx(Tabs.Content, { name: NOB.DOWNSTREAM_UPSTREAM.US_CHANNEL, tabId: "tab-3", children: _jsx(StreamChannel, { channels: devicePollingMacCorrected.UsChannels, type: UPSTREAM, scoreVariables: devicePollingMacCorrected.ScoreVariables }) })] })) }));
};
const mapStateToProps = (state) => ({
    devicePollingMac: state.devicePollingMac.devicePollingMac,
    errorMessage: state.devicePollingMac.errorMessage,
    isReceiveFetching: state.devicePollingMac.isFetching,
    isUpdateFetching: state.updateDevicePollingMac.isFetching,
});
const mapDispatchToProps = (dispatch) => ({
    requestDevicePollingMacFunc: (pollUrl) => dispatch(requestDevicePollingMac(pollUrl)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Sam);
